import axios from "axios";
import { store } from "../../App";
import { LoginApi } from "../../db/APIs/AuthAPI";
import { bioLogin } from "../../db/BioStar/APIs";

export const LOGIN = (email, password) => {
  return async (dispatch) => {
    try {
      const centerId = JSON.parse(localStorage.getItem('centerId')).centerId
      let res = await LoginApi(email, password);
      res = res.data;
      if (!res.user.center.includes(centerId)) {
        throw 'invalid center'
      }

      if (res.user.type !== 4) {
        await bioLogin().catch(e => {alert('login for face machine failed')});
      }
      localStorage.setItem("Auth", JSON.stringify(res));
      axios.defaults.headers.common["Authorization"] = `Bearer ${res.token}`
      dispatch({
        type: "LOGIN",
        data: res.user,
      });
    } catch (e) {
      throw e;
    }
  };
};

export const LOGOUT = () => {
  localStorage.removeItem("Auth");
  store.dispatch({
    type: "LOGOUT",
  });
};
